import Card from "olive-react-myoneui/lib/Card";

function NoItems({
  className = "",
  icon = null,
  title = "No items to show!",
  description = "There are no items available. Start by adding a new one!"
}) {
  return (
    <Card className={`${className} myk__stu-empty-items empty-block-card border-0`}>
      <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
        <div className="empty-block">
          {icon && <div className="icon-wrapper">{icon}</div>}
          <div className="myk__stu-content-empty">
            <h6><strong>{title}</strong></h6>
            <p>{description}</p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default NoItems;
